"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GeometryFactory = _interopRequireDefault(require("../../geom/GeometryFactory"));

var _Coordinate = _interopRequireDefault(require("../../geom/Coordinate"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OffsetSegmentString =
/*#__PURE__*/
function () {
  function OffsetSegmentString() {
    _classCallCheck(this, OffsetSegmentString);

    OffsetSegmentString.constructor_.apply(this, arguments);
  }

  _createClass(OffsetSegmentString, [{
    key: "getCoordinates",
    value: function getCoordinates() {
      var coord = this._ptList.toArray(OffsetSegmentString.COORDINATE_ARRAY_TYPE);

      return coord;
    }
  }, {
    key: "setPrecisionModel",
    value: function setPrecisionModel(precisionModel) {
      this._precisionModel = precisionModel;
    }
  }, {
    key: "addPt",
    value: function addPt(pt) {
      var bufPt = new _Coordinate.default(pt);

      this._precisionModel.makePrecise(bufPt);

      if (this.isRedundant(bufPt)) return null;

      this._ptList.add(bufPt);
    }
  }, {
    key: "reverse",
    value: function reverse() {}
  }, {
    key: "addPts",
    value: function addPts(pt, isForward) {
      if (isForward) {
        for (var i = 0; i < pt.length; i++) {
          this.addPt(pt[i]);
        }
      } else {
        for (var i = pt.length - 1; i >= 0; i--) {
          this.addPt(pt[i]);
        }
      }
    }
  }, {
    key: "isRedundant",
    value: function isRedundant(pt) {
      if (this._ptList.size() < 1) return false;

      var lastPt = this._ptList.get(this._ptList.size() - 1);

      var ptDist = pt.distance(lastPt);
      if (ptDist < this._minimimVertexDistance) return true;
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      var fact = new _GeometryFactory.default();
      var line = fact.createLineString(this.getCoordinates());
      return line.toString();
    }
  }, {
    key: "closeRing",
    value: function closeRing() {
      if (this._ptList.size() < 1) return null;
      var startPt = new _Coordinate.default(this._ptList.get(0));

      var lastPt = this._ptList.get(this._ptList.size() - 1);

      var last2Pt = null;
      if (this._ptList.size() >= 2) last2Pt = this._ptList.get(this._ptList.size() - 2);
      if (startPt.equals(lastPt)) return null;

      this._ptList.add(startPt);
    }
  }, {
    key: "setMinimumVertexDistance",
    value: function setMinimumVertexDistance(minimimVertexDistance) {
      this._minimimVertexDistance = minimimVertexDistance;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return OffsetSegmentString;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return OffsetSegmentString;
}();

exports.default = OffsetSegmentString;

OffsetSegmentString.constructor_ = function () {
  this._ptList = null;
  this._precisionModel = null;
  this._minimimVertexDistance = 0.0;
  this._ptList = new _ArrayList.default();
};

OffsetSegmentString.COORDINATE_ARRAY_TYPE = new Array(0).fill(null);